import { X } from "lucide-react";

import { useAttachments } from "./use-attachments";
import { formatFileSize } from "./utils";
import { cn } from "~/util/cn";

export type AttachmentsManagerHandle = {
  reset: () => void;
};

type AttachmentsManagerProps = {
  attachments: ReturnType<typeof useAttachments>;
  className?: string;
};

export const AttachmentsManager: React.FC<AttachmentsManagerProps> = ({
  attachments: { list, remove },
  className,
}) => {
  return (
    <div className={cn("flex flex-wrap gap-5", className)}>
      {list.map((attachment) => (
        <div
          key={attachment.id}
          className="relative rounded-lg border border-neutral/20 bg-base-100 p-1 shadow-sm"
        >
          {attachment.file.type.startsWith("image/") ? (
            <div
              className="tooltip tooltip-top"
              data-tip={`${attachment.name} (${formatFileSize(
                attachment.size,
              )})`}
            >
              <img
                src={attachment.preview}
                alt={attachment.name}
                className="h-16 w-16 rounded object-cover"
                onError={(e) => {
                  e.currentTarget.src = "";
                  e.currentTarget.classList.add("bg-base-300");
                  e.currentTarget.alt = "Preview unavailable";
                }}
              />
            </div>
          ) : (
            <div className="flex h-16 w-16 items-center justify-center rounded bg-base-300">
              <span className="text-xs">
                {attachment.name.split(".").pop()?.toUpperCase() || ""}
              </span>
            </div>
          )}
          <button
            className="absolute -right-2 -top-2 rounded-full border border-neutral/10 bg-base-300 p-1 shadow-md hover:bg-base-200"
            onClick={() => remove(attachment.id)}
            type="button"
            aria-label="Remove attachment"
          >
            <X size={12} />
          </button>
        </div>
      ))}
    </div>
  );
};

AttachmentsManager.displayName = "AttachmentsManager";
